import { DelayAct } from '../models/DelayAct';
import { DelayActHttp } from '../services/http/DelayHttp';
import { createImmutableDataFetchStore } from '../utilities/ImmutableDataFetchStore';

export const useDelayStore = createImmutableDataFetchStore<DelayAct[], void>(() => new DelayActHttp().get());
